import React from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { useMediaQuery } from 'react-responsive';
import * as Device from 'expo-device';

import arequipaLogo from '../../assets/img/logos/arequipa-institute-logo.png';
import discoveryLogo from '../../assets/img/logos/discovery-park-logo.png';
import unsaLogo from '../../assets/img/logos/unsa-logo.png';

function WebLogos() {
  return (
    <View style={styles.container}>
      <Image
        style={styles.logoWeb}
        source={unsaLogo}
        resizeMethod="resize"
        resizeMode="contain"
      />
      <Image
        style={styles.logoWeb}
        source={arequipaLogo}
        resizeMethod="resize"
        resizeMode="contain"
      />
      <Image
        style={styles.logoWeb}
        source={discoveryLogo}
        resizeMethod="resize"
        resizeMode="contain"
      />
    </View>
  );
}

export default function Footer() {
  const isTabletOrMobileDevice = useMediaQuery({
    maxDeviceWidth: 1224,
  });

  return !Device.brand && !isTabletOrMobileDevice ? <WebLogos /> : null;
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    backgroundColor: '#e0ddd9',
    padding: 15,
    textAlign: 'center',
  },
  logoWeb: {
    height: 50,
    width: 200,
  },
});
